import adapter from './adapter'

export default {
  confirm: adapter('api/confirm'),
  events: adapter('api/events'),
  groups: adapter('api/groups'),
  reservations: adapter('api/reservations'),
  ridingschool: adapter('api/ridingschool'),
  templates: adapter('api/templates')
}
